import Promotion from './Promotion';

const PROMOTION_ICONS = {
  basic_deal: <i className="fa-regular fa-tag" style={{ fontSize: 12 }} />,
  early_booker: (
    <i className="fa-regular fa-alarm-clock" style={{ fontSize: 12 }} />
  ),
  last_minute: (
    <i className="fa-regular fa-stopwatch" style={{ fontSize: 12 }} />
  ),
};

const PromotionTag = ({
  name,
  kind,
  bgColor,
}: {
  name?: string;
  kind?: keyof typeof PROMOTION_ICONS;
  bgColor?: string;
}) => {
  // Remove the amount from the promotion name
  const promotionName = typeof name === 'string' ? name.trim() : undefined;

  return (
    <Promotion bgColor={bgColor}>
      {kind && <div>{PROMOTION_ICONS[kind]}</div>}
      {promotionName && <span>{promotionName}</span>}
    </Promotion>
  );
};

export default PromotionTag;
